import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles/tw.merge";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    isDisabled: boolean;
    onSubmit: () => void;
    size?: "md" | "sm" | "lg";
    fullWidth?: boolean;
    className?: string;
};

const OrderButton = ({
    isDisabled,
    onSubmit,
    size = "md",
    fullWidth = true,
    className
}: Props) => {
    const { t } = useGranite();

    return (
        <Button
            test="orderButton-button-submit"
            color="success"
            disabled={isDisabled}
            onClick={onSubmit}
            type="button"
            size={size}
            fullWidth={fullWidth}
            className={className}
        >
            <span className={cn("tw:hidden tw:md:block")}>
                {t("ecommerce.button.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
            <span className={cn("tw:md:hidden")}>
                {t("ecommerce.buttonMobile.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
        </Button>
    );
};

export default OrderButton;
